import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class VocationalEducation  {
    _originalTypeClassName = "zERP.BO.VocationalEducation";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
VocationalEducation.translate = translateService;
}
this.Id = null;
this.Name = null;
this.Description = null;
this.Duration = null;
this.Cost = null;
this.Mandatory = false;
this.From = null;
this.To = null;
this.Code_ = null;
this.DocumentType = null;
this.DocumentDescription = null;
this.DocumentPath = null;
this.hasActiveContract = false;
this.YearAcquired = null;
this.HRComment = null;
this.EmpComment = null;
this.State = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
Duration:any;
Cost:any;
Mandatory:any;
From:any;
To:any;
Code_:any;
DocumentType:any;
DocumentDescription:any;
DocumentPath:any;
hasActiveContract:any;
YearAcquired:any;
HRComment:any;
EmpComment:any;
State:any;
Employee:any;
Diploma:any;
SubjectGroup:any;
EducationAgency:any;
EmployeeCategory:any;
KnowledgeDomain:any;
Institution:any;
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
if (oldValue != null) {
Domain.Employee.removeVocationalEducation(oldValue, $this);
}
Domain.Employee.addVocationalEducation(value, $this);
}
}
static setDiploma = ($this, value) => {
var oldValue = $this.Diploma;
$this.Diploma = value;
if (value != null) {
}
}
static setSubjectGroup = ($this, value) => {
var oldValue = $this.SubjectGroup;
$this.SubjectGroup = value;
if (value != null) {
}
}
static setEducationAgency = ($this, value) => {
var oldValue = $this.EducationAgency;
$this.EducationAgency = value;
if (value != null) {
}
}
static setEmployeeCategory = ($this, value) => {
var oldValue = $this.EmployeeCategory;
$this.EmployeeCategory = value;
if (value != null) {
}
}
static setKnowledgeDomain = ($this, value) => {
var oldValue = $this.KnowledgeDomain;
$this.KnowledgeDomain = value;
if (value != null) {
}
}
static setInstitution = ($this, value) => {
var oldValue = $this.Institution;
$this.Institution = value;
if (value != null) {
}
}

static GetClassName(): any{return "VocationalEducation";
}
static ParseMandatory(el: any): any{return (!(CLMS.Framework.String.IsNullOrEmpty(el)) && !(CLMS.Framework.String.IsNullOrEmpty((el ?? '').trim())) && el == "ΝΑΙ" ? true : false);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}